export const GREY_COLOR = "#A5A5A5";
export const LIGHT_GREY_COLOR = "#5A5A5A";
export const BORDER_GREY_COLOR = "#D8D8D8";
export const TAB_GREEN_COLOR = "#A5C300";

export const FONT_FAMILY = "Ubuntu";

export const PIE_CHART_COLORS = {
  GREEN: "#259E55",
  ORANGE: "#F49C4B",
  RED: "#E13976",
};
export const STATUS_COLORS = {
  GREEN: "#259E55",
  ORANGE: "#F49C4B",
  RED: "#E13976",
};
export const LINE_CHART_COLORS = {
  GREEN: "#006C00",
  ORANGE: "#FF9C00",
  RED: "#f51414",
};
